export const CLIENT_STATUS = {
  SUSPENDED: 'suspended',
  MEMBERSHIP: 'membership',
  PACKAGE: 'package',
  INTRO: 'intro',
  ALUMNI: 'alumni',
  AGGREGATOR: 'aggregator',
  LEAD: 'lead',
}

export const getStatusStyles = (status) => {
  const statusColorMap = {
    [CLIENT_STATUS.SUSPENDED]: { bgcolor: 'warning.lightest', color: 'warning.dark' },
    [CLIENT_STATUS.MEMBERSHIP]: { bgcolor: 'success.lightest', color: 'success.dark' },
    [CLIENT_STATUS.PACKAGE]: { bgcolor: 'blue.lightest', color: 'blue.dark' },
    [CLIENT_STATUS.INTRO]: { bgcolor: 'secondary.lightest', color: 'secondary.dark' },
    [CLIENT_STATUS.AGGREGATOR]: { bgcolor: 'orange.lightest', color: 'orange.dark' },
    [CLIENT_STATUS.ALUMNI]: { bgcolor: 'grey.100', color: 'grey.700' },
    [CLIENT_STATUS.LEAD]: { bgcolor: 'orange.lightest', color: 'orange.dark' },
    default: { bgcolor: 'grey.100', color: 'grey.700' },
  }
  return statusColorMap[status] || statusColorMap.default
}

export const getClientNameStyle = (isSelected, styleBase) => {
  if (isSelected) {
    return {
      ...styleBase,
      color: 'primary.dark',
    }
  }
  return styleBase
}

export const getStatusBadgeStyle = (status, styleBase) => {
  const statusColors = getStatusStyles(status)
  return {
    ...styleBase,
    bgcolor: statusColors.bgcolor,
    color: statusColors.color,
  }
}

export const getAvatarStyle = (clientId, baseStyle, getAvatarColorFn) => ({
  ...baseStyle,
  bgcolor: getAvatarColorFn(clientId),
})

export const secondaryActionStyles = {
  color: 'grey.700',
  backgroundColor: 'black',
  borderRadius: '24px',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
}

export const customHeaderStyles = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'column', md: 'row' },
  justifyContent: { sm: 'space-between' },
  alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' },
  marginBottom: { xs: 2, sm: 2, md: 2 },
  paddingX: { xs: 2, sm: 'unset' },
  width: '100%',
  gap: { xs: 1, sm: 1, md: 2 },
  '& > div:first-of-type': {
    width: '100%',
    flex: { md: 1 },
    minWidth: 0,
    '& .MuiTextField-root': {
      width: '100% !important',
    },
    '& .MuiSvgIcon-root': {
      color: 'green.dark !important',
    },
  },
}

export const corporateLookupButtonStyles = {
  textTransform: 'none',
  backgroundColor: 'transparent',
  color: 'primary.main',
  border: 'none',
  padding: { xs: '6px 8px', sm: '8px 12px' },
  fontSize: 'body2.fontSize',
  fontWeight: 'bold',
  minHeight: 'auto',
  minWidth: 'auto',
  whiteSpace: 'nowrap',
  boxShadow: 'none',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'primary.dark',
    boxShadow: 'none',
    textDecoration: 'underline',
  },
}

export const corporateLookupButtonContainer = {
  display: 'flex',
  alignItems: 'center',
  ml: 1,
  flexShrink: 0,
  minWidth: 'fit-content',
}

export const customActionsStyles = {
  container: {
    display: 'flex',
    gap: 2,
    alignItems: 'center',
    width: { xs: '100%', sm: '100%', md: 'auto' },
    flexDirection: { xs: 'row-reverse', sm: 'row-reverse', md: 'row' },
    px: { xs: 0, sm: 'unset', md: 'unset' },
    mx: { xs: 0, sm: 0, md: 0 },
    pt: { xs: 0.5, sm: 'unset', md: 'unset' },
    mb: { xs: 2, sm: 0, md: 0 },
  },
  divider: {
    display: { xs: 'none', md: 'block' },
    height: 32,
    borderColor: 'divider',
    ml: 2,
    mr: 2,
  },
  filterButton: {
    minWidth: 'auto !important',
    minHeight: 'auto !important',
    padding: '8px !important',
    borderRadius: '24px',
    backgroundColor: 'background.paper',
    color: 'grey.600',
    border: '1px solid',
    borderColor: 'grey.300',
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'grey.50',
      borderColor: 'grey.400',
      boxShadow: 'none',
    },
    '& .MuiButton-startIcon': {
      margin: '0 !important',
    },
  },
  addClientButton: {
    textTransform: 'none',
    borderRadius: '24px',
    backgroundColor: 'primary.main',
    color: 'white',
    padding: '8px 16px',
    boxShadow: 'none',
    border: 'none',
    flex: { xs: 1, sm: 1, md: 'none' },
    fontSize: 'body2.fontSize',
    '&:hover': {
      opacity: 0.9,
      boxShadow: 'none',
    },
  },
}

export const clientsPageStyles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    height: 64,
    display: 'flex',
    alignItems: 'center',
    px: 2,
    borderBottom: 1,
    borderColor: 'divider',
    bgcolor: 'background.paper',
  },
  tabsContainer: {
    bgcolor: 'background.paper',
  },
  tabsWrapper: {
    px: 3,
  },
  tabsInner: {
    display: 'flex',
    gap: 0.5,
    px: 2,
    py: 1.5,
    alignItems: 'center',
  },
  manageButton: {
    textTransform: 'none',
    fontWeight: 'medium',
    borderRadius: { xs: '50%', sm: 1 },
    minWidth: { xs: 'auto', sm: 'auto' },
    px: { xs: 1, sm: 2 },
    py: 0.75,
    fontSize: 'body2.fontSize',
    border: 'none',
    boxShadow: 'none',
    color: 'text.secondary',
    bgcolor: 'transparent',
    '&:hover': {
      bgcolor: 'action.hover',
      color: 'primary.main',
    },
  },
  settingsIcon: {
    fontSize: 'h4.fontSize',
  },
  tabsLoading: {
    display: 'flex',
    alignItems: 'center',
    px: 2,
  },
  tabsLoadingInner: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'scale(0.5)',
    transformOrigin: 'center',
  },
  tabButton: (isActive) => ({
    textTransform: 'none',
    fontWeight: isActive ? 'semiBold' : 'medium',
    borderRadius: 1,
    minWidth: 'auto',
    px: 2,
    py: 0.75,
    fontSize: 'body2.fontSize',
    border: 'none',
    boxShadow: 'none',
    ...(isActive
      ? {
          bgcolor: 'primary.lightest',
          color: 'primary.main',
          '&:hover': {
            color: 'primary.darkest',
          },
        }
      : {
          color: 'text.secondary',
          bgcolor: 'transparent',
          '&:hover': {
            bgcolor: 'action.hover',
            color: 'primary.main',
          },
        }),
  }),
  content: {
    flex: 1,
    px: { xs: 2, sm: 5 },
    pt: 1.5,
    pb: 2,
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  actions: {
    container: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
      mb: 2,
      px: 2,
    },
    filterButton: {
      width: 131,
      height: 40,
      borderRadius: '24px',
      padding: '8px 20px 8px 12px',
      backgroundColor: 'background.paper',
      color: 'green.main',
      borderColor: 'green.main',
      textTransform: 'none',
      mr: 1,
      '&:hover': {
        backgroundColor: 'green.lightest',
        borderColor: 'green.main',
        color: 'green.main',
      },
      '& .MuiButton-startIcon': {
        marginRight: 1,
      },
    },
    addButton: {
      width: 131,
      height: 40,
      borderRadius: '24px',
      padding: '8px 20px 8px 12px',
      backgroundColor: 'green.main',
      color: 'black',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'green.main',
      },
      '& .MuiButton-startIcon': {
        marginRight: 1,
      },
    },
    divider: {
      height: 32,
      borderColor: 'divider',
      ml: 2,
      mr: 3,
    },
  },
  tabDivider: {
    height: 24,
    mx: 1,
    borderColor: 'divider',
  },
  table: {
    '& .MuiTableHead-root': {
      '& .MuiTableCell-root': {
        bgcolor: 'grey.50',
        borderBottom: 1,
        borderColor: 'divider',
        fontWeight: 'semiBold',
        fontSize: 'caption.fontSize',
        color: 'green.main',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:hover': {
          bgcolor: 'action.hover',
        },
        '&.selected': {
          bgcolor: 'action.selected',
          '& .MuiTableRow-root:has(.MuiCheckbox-root.Mui-checked)': {
            bgcolor: 'action.selected',
            '& .client-name': {
              color: 'green.dark !important',
            },
            '& .phone-value': {
              color: 'green.dark !important',
            },
            '& .barcode-value': {
              color: 'green.dark !important',
            },
          },
        },
      },
      '& .MuiTableCell-root': {
        borderBottom: 1,
        borderColor: 'divider',
        fontSize: 'body2.fontSize',
      },
    },
  },
  emptyState: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center',
      py: 8,
      px: 4,
      minHeight: '400px',
      width: '100%',
    },
    iconContainer: {
      width: 64,
      height: 64,
      borderRadius: '50%',
      backgroundColor: 'orange.lightest',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      mb: 3,
    },
    icon: {
      fontSize: 'h1.fontSize',
      color: 'orange.dark',
      backgroundColor: 'orange.lightest',
      width: 32,
      height: 32,
    },
    title: {
      mb: 1,
      fontWeight: 'semiBold',
    },
    description: {
      mb: 4,
      maxWidth: 400,
    },
    button: {
      minWidth: { xs: 'auto', sm: 'auto', md: '120px' },
      borderRadius: '24px',
      backgroundColor: 'primary.main',
      color: 'white',
      textTransform: 'none',
      boxShadow: 'none',
      border: '1px solid',
      borderColor: 'primary.main',
      '&:hover': {
        opacity: 0.9,
        boxShadow: 'none',
      },
      '& .MuiButton-startIcon': {
        marginRight: 1,
      },
    },
  },
  mobileTable: {
    scrollContainer: {
      maxHeight: 'calc(100vh - 200px)',
      overflow: 'auto',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    container: {
      borderTop: 'none',
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'divider',
      borderBottomLeftRadius: 1,
      borderBottomRightRadius: 1,
      bgcolor: 'background.paper',
    },
    row: {
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    rowContent: {
      display: 'flex',
      alignItems: 'center',
      p: 2,
      gap: { xs: 0.5, sm: 1 },
      '&:hover': { bgcolor: 'grey.50' },
    },
    clientInfo: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
    },
    clientInfoCentered: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    clientInfoTop: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    clientName: {
      fontSize: 'body2.fontSize',
    },
    clientNameClickable: {
      fontSize: 'body2.fontSize',
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&:hover': {
        color: 'green.main',
        textDecoration: 'underline',
      },
    },
    clientNameClickableSelected: {
      fontSize: 'body2.fontSize',
      cursor: 'pointer',
      color: 'green.dark',
      '&:hover': {
        color: 'green.dark',
        textDecoration: 'underline',
      },
    },
    alertsContainer: {
      mt: 0.25,
    },
    chevron: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: 1,
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
    },
    chevronExpanded: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: 1,
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
      transform: 'rotate(180deg)',
    },
    chevronCollapsed: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: 1,
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
      transform: 'rotate(0deg)',
    },
    expandedContent: {
      bgcolor: 'grey.25',
      borderTop: '1px solid',
      borderColor: 'divider',
    },
    detailRow: {
      display: 'flex',
      borderBottom: '1px solid',
      borderColor: 'divider',
    },
    detailRowLast: {
      display: 'flex',
      borderBottom: 'none',
    },
    detailLabel: {
      bgcolor: 'grey.200',
      px: 2,
      py: 1.5,
      width: { xs: 80, sm: 100 },
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
    },
    detailLabelText: {
      variant: 'body2',
      color: 'text.secondary',
      fontWeight: 'medium',
      whiteSpace: 'nowrap',
    },
    detailValue: {
      px: 2,
      py: 1.5,
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
    },
    detailValueText: {
      variant: 'body2',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
    },
    statusBadge: {
      px: 1,
      py: 0.5,
      borderRadius: 1,
      display: 'inline-block',
    },
    statusBadgeClickable: {
      px: 1,
      py: 0.5,
      borderRadius: 1,
      display: 'inline-block',
      cursor: 'pointer',
      fontSize: 'body2.fontSize',
      fontWeight: 'semiBold',
      '&:hover': {
        opacity: 0.8,
      },
    },
    card: {
      mb: 2,
      p: 2,
      bgcolor: 'background.paper',
      borderRadius: 1,
      boxShadow: 1,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      mb: 2,
    },
    avatar: {
      mr: 2,
    },
    clientEmail: {
      variant: 'body2',
      color: 'text.secondary',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    alerts: {
      mr: 2,
    },
    details: {
      display: 'grid',
      gap: 1,
    },
    loadingIndicator: {
      display: 'flex',
      justifyContent: 'center',
      p: 2,
    },
  },

  tabletTable: {
    container: {
      borderTop: 'none',
      borderLeft: '1px solid',
      borderRight: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'divider',
      borderBottomLeftRadius: 1,
      borderBottomRightRadius: 1,
      bgcolor: 'background.paper',
    },
    row: {
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    rowContent: {
      display: 'flex',
      alignItems: 'center',
      p: 2,
      '&:hover': { bgcolor: 'grey.50' },
    },
    checkbox: {
      mr: 2,
      flexShrink: 0,
    },
    avatar: {
      mr: 2,
      width: 40,
      height: 40,
      flexShrink: 0,
    },
    avatarDynamic: (avatarColor) => ({
      mr: 2,
      width: 40,
      height: 40,
      bgcolor: avatarColor || 'primary.main',
      flexShrink: 0,
    }),
    clientInfo: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0%',
      width: 10,
      minWidth: 0,
      overflow: 'hidden',
    },
    clientName: {
      fontWeight: 'bold',
      mb: 0.5,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    clientNameClickable: {
      fontWeight: 'bold',
      mb: 0.5,
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&:hover': {
        color: 'green.main',
        textDecoration: 'underline',
      },
    },
    clientNameClickableSelected: {
      fontWeight: 'bold',
      mb: 0.5,
      cursor: 'pointer',
      color: 'green.dark',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&:hover': {
        color: 'green.dark',
        textDecoration: 'underline',
      },
    },
    clientEmail: {
      color: 'text.secondary',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    alerts: {
      mr: 2,
      flexShrink: 0,
    },
    chevron: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: '50%',
      width: 32,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
      flexShrink: 0,
    },
    chevronExpanded: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: '50%',
      width: 32,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
      transform: 'rotate(180deg)',
      flexShrink: 0,
    },
    chevronCollapsed: {
      ml: 1,
      cursor: 'pointer',
      p: 0.5,
      borderRadius: '50%',
      width: 32,
      height: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': { bgcolor: 'grey.100' },
      transition: 'transform 0.2s ease',
      color: 'text.secondary',
      transform: 'rotate(0deg)',
      flexShrink: 0,
    },
    expandedContent: {
      bgcolor: 'grey.25',
      borderTop: '1px solid',
      borderColor: 'divider',
    },
    detailRow: {
      display: 'flex',
      borderBottom: '1px solid',
      borderColor: 'divider',
    },
    detailRowLast: {
      display: 'flex',
      borderBottom: 'none',
    },
    detailLabel: {
      bgcolor: 'grey.200',
      px: 2,
      py: 1.5,
      width: { xs: 80, sm: 100 },
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
    },
    detailLabelText: {
      variant: 'body2',
      color: 'text.secondary',
      fontWeight: 'medium',
      whiteSpace: 'nowrap',
    },
    detailValue: {
      px: 2,
      py: 1.5,
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
    },
    detailValueText: {
      variant: 'body2',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
    },
    statusBadge: {
      px: 1,
      py: 0.5,
      borderRadius: 1,
      display: 'inline-block',
    },
    statusBadgeClickable: {
      px: 1,
      py: 0.5,
      borderRadius: 1,
      display: 'inline-block',
      cursor: 'pointer',
      fontSize: 'body2.fontSize',
      fontWeight: 'semiBold',
      '&:hover': {
        opacity: 0.8,
      },
    },
    loadingIndicator: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 2,
      marginTop: 1,
    },
  },
}

export const clientsTableStyles = {
  checkbox: {
    '&.Mui-checked': {
      color: 'green.dark',
    },
    '&.MuiCheckbox-indeterminate': {
      color: 'green.dark',
    },
    '&:hover': {
      backgroundColor: 'action.hover',
      '&.Mui-checked': {
        color: 'green.dark',
      },
    },
    '& .MuiSvgIcon-root': {
      fontSize: 'h6.fontSize',
    },
  },
  phone: {
    typography: {
      color: 'gray.70',
    },
    typographySelected: {
      color: 'green.dark',
    },
  },
  barcode: {
    typography: {
      color: 'gray.70',
      fontFamily: 'monospace',
    },
    typographySelected: {
      color: 'green.dark',
      fontFamily: 'monospace',
    },
  },
  clientName: {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      cursor: 'pointer',
      minWidth: 0,
      overflow: 'hidden',
      '&:hover': {
        '& .client-name': {
          color: 'green.dark',
          textDecoration: 'underline',
        },
      },
    },
    avatar: {
      width: 40,
      height: 40,
      fontSize: 'body1.fontSize',
      fontWeight: 'semiBold',
      flexShrink: 0,
    },
    textContainer: {
      minWidth: 0,
      overflow: 'hidden',
      flex: 1,
    },
    name: {
      transition: 'all 0.2s ease',
      color: 'gray.80',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      width: '100%',
    },
    nameSelected: {
      transition: 'all 0.2s ease',
      color: 'green.dark',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      width: '100%',
    },
    email: {
      color: 'gray.60',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      width: '100%',
    },
    emailSelected: {
      color: 'green.dark',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      width: '100%',
    },
  },

  alerts: {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    count: {
      ml: 1,
    },
    alertBox: (alert, index) => ({
      width: 32,
      height: 32,
      borderRadius: '40px',
      backgroundColor: alert.color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      zIndex: index + 1,
      marginLeft: index > 0 ? '-10px' : '0px',
      border: '2px solid white',
      padding: '8px',
    }),
    mobileAlertBox: (alert, index) => ({
      width: 24,
      height: 24,
      borderRadius: '40px',
      backgroundColor: alert.color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      zIndex: index + 1,
      marginLeft: index > 0 ? '-8px' : '0px',
      border: '2px solid white',
      padding: '4px',
    }),
    alertIcon: (iconColor) => ({
      fontSize: 'h6.fontSize',
      color: iconColor,
    }),
    mobileAlertIcon: (iconColor) => ({
      fontSize: 'body2.fontSize',
      color: iconColor,
    }),
  },
  actions: {
    container: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    menu: {
      overflow: 'visible',
      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
      mt: 1.5,
      '& .MuiAvatar-root': {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1,
      },
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 14,
        width: 80,
        height: 80,
        bgcolor: 'background.paper',
        transform: 'translateY(-50%) rotate(45deg)',
        zIndex: 0,
      },
    },
    menuPaper: {
      minWidth: 160,
    },
    mobileDrawer: {
      '& .MuiDrawer-paper': {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        maxHeight: '50vh',
      },
    },
    mobileDrawerContent: {
      p: 1,
      pb: 1,
    },
    mobileMenuItem: {
      py: 2,
      px: 0,
      mx: 0,
      borderRadius: 0,
      fontSize: 'body2.fontSize',
      width: '100%',
      '&:hover': {
        bgcolor: 'action.hover',
      },
    },
    mobileMenuIcon: {
      minWidth: 40,
      color: 'text.secondary',
    },
    mobileMenuText: {
      '& .MuiTypography-root': {
        fontSize: 'body2.fontSize',
        fontWeight: 'medium',
      },
    },
  },
  status: {
    button: {
      width: 104,
      height: 32,
      fontWeight: 'semiBold',
      fontSize: 'body2.fontSize',
      lineHeight: '20px',
      letterSpacing: 0,
      textAlign: 'center',
      textTransform: 'none',
      borderRadius: 0.5,
      padding: '6px 12px',
      cursor: 'pointer',
      border: 'none',
      boxShadow: 'none',
      '&:hover': {
        opacity: 0.8,
      },
    },
    disabledButton: {
      width: 104,
      height: 32,
      fontWeight: 'semiBold',
      fontSize: 'body2.fontSize',
      lineHeight: '20px',
      letterSpacing: 0,
      textAlign: 'center',
      textTransform: 'none',
      cursor: 'default',
      borderRadius: 0.5,
      padding: '6px 12px',
      '&.Mui-disabled': {
        border: 'none',
        boxShadow: 'none',
      },
    },
  },
  phoneValidation: {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      mt: 0.25,
    },
    icon: {
      fontSize: 'caption.fontSize',
      color: 'error.main',
    },
    text: {
      color: 'error.main',
      fontSize: 'caption.fontSize',
    },
  },
}

export const clientOverviewStyles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    p: 3,
  },
  mergedBannerIcon: {
    fontSize: 48,
    color: 'text.secondary',
    mb: 1,
  },
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    bgcolor: 'background.paper',
    borderBottom: 1,
    borderColor: 'divider',
    p: { xs: 2, sm: 3 },
  },
  headerActions: {
    display: 'flex',
    alignItems: { xs: 'flex-start', md: 'center' },
    justifyContent: 'space-between',
    mt: 2,
    gap: 2,
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    width: '100%',
  },
  headerProfile: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flex: '1 1 auto',
    minWidth: 0,
    flexWrap: { xs: 'wrap', sm: 'nowrap' },
  },
  homeLocation: {
    ml: 2,
    flexShrink: 1,
    minWidth: 0,
    maxWidth: 220,
    display: { xs: 'none', sm: 'flex' },
    flexDirection: 'column',
    overflow: 'hidden',
  },
  backButton: {
    mr: 1,
  },
  avatar: (avatarColor) => ({
    width: 64,
    height: 64,
    fontSize: 'h4.fontSize',
    fontWeight: 'semiBold',
    bgcolor: avatarColor,
  }),
  avatarClickable: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  headerButtons: {
    display: 'flex',
    gap: 1,
    flexWrap: { xs: 'wrap', md: 'nowrap' },
    justifyContent: { xs: 'flex-start', md: 'flex-end' },
    width: { xs: '100%', md: 'auto' },
    flexShrink: 0,
  },
  headerButton: {
    borderColor: 'divider',
    borderRadius: 5,
    flex: { xs: '1 1 calc(50% - 4px)', sm: '0 0 auto' },
    minWidth: { xs: 0, sm: 'auto' },
  },
  mainContentFlex: {
    display: 'flex',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    minHeight: 0,
    minWidth: 0,
  },
  sidebar: {
    position: 'sticky',
    top: 0,
    alignSelf: 'flex-start',
    bgcolor: 'background.paper',
    pl: 5,
    py: 2,
  },
  sidebarList: {
    p: 0,
    width: 300,
  },
  sidebarItem: {
    mt: 1,
    py: 1,
    px: 1.5,
    borderRadius: 1,
    gap: 2,
    '&.Mui-selected': {
      bgcolor: 'primary.lightest',
      '& .MuiSvgIcon-root': {
        color: 'primary.dark',
      },
      '& .MuiListItemText-root': {
        color: 'primary.dark',
        fontWeight: '600',
      },
    },
    '& .MuiListItemText-root': {
      margin: 0,
    },
  },
  sidebarIcon: {
    color: 'gray.64',
    width: 24,
    height: 24,
    minWidth: 'auto',
  },

  sidebarText: {
    fontSize: 'body1.fontSize',
  },
  content: {
    flex: 1,
    minWidth: 0,
    overflowX: 'hidden',
    p: { xs: 2, sm: 3 },
  },
  attendanceCard: {
    mb: 3,
  },
  attendanceHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    mb: 3,
    flexWrap: 'wrap',
    gap: 1,
  },
  attendanceTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  attendanceContent: {
    display: 'flex',
    gap: 4,
    flexDirection: { xs: 'column', sm: 'row' },
  },
  attendanceLastAttendance: {
    textAlign: 'right',
  },
  attendanceMetrics: {
    minWidth: 140,
    flexShrink: 0,
  },
  attendanceMetricItem: {
    mb: 2.5,
  },
  attendanceChartWrapper: {
    flex: 1,
    minWidth: 0,
  },
  attendanceChart: {
    container: {
      display: 'flex',
      height: 180,
      gap: 1,
    },
    yAxis: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      pr: 1,
      pb: 3,
    },
    barsWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      flex: 1,
      gap: 1.5,
      borderLeft: '1px solid',
      borderBottom: '1px solid',
      borderColor: 'divider',
      pl: 1,
      pb: 0,
    },
    barContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
      justifyContent: 'flex-end',
      height: '100%',
      pb: 0.5,
    },
    countLabel: (isCurrentMonth) => ({
      color: isCurrentMonth ? 'success.main' : 'text.secondary',
    }),
    bar: (value, maxValue, isCurrentMonth) => ({
      width: '100%',
      maxWidth: 32,
      height: maxValue > 0 ? `${(value / maxValue) * 70}%` : 0,
      minHeight: value > 0 ? 4 : 0,
      bgcolor: isCurrentMonth ? 'primary.light' : 'grey.300',
      borderRadius: '4px 4px 0 0',
      mt: 0.5,
      mb: 0.5,
    }),
  },
  upcomingSessionsContainer: {
    border: 1,
    borderColor: 'divider',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  upcomingSessionRow: {
    container: {
      display: 'flex',
      gap: 2,
      px: 2.5,
      py: 2,
      alignItems: 'flex-start',
    },
    timeColumn: {
      width: '72px',
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
    },
    detailsColumn: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 0.25,
    },
    rightSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 1,
      minHeight: '64px',
    },
    statusContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
    },
    statusCheckmark: {
      color: 'success.main',
      fontSize: 12,
      mr: 0.5,
      fontWeight: 600,
    },
    buttonGroup: {
      display: 'flex',
      gap: 1,
    },
    dateHeader: {
      backgroundColor: 'grey.50',
      px: 3,
      py: 1.75,
      borderBottom: 1,
      borderColor: 'divider',
    },
  },
  credits: {
    mainSection: {
      mb: 3,
    },
    billingRow: {
      display: 'flex',
      justifyContent: 'space-between',
      mb: 1,
    },
    accountSection: {
      display: 'flex',
      justifyContent: 'space-between',
      mb: 1,
    },
    divider: {
      my: 2,
    },
  },
  placeholder: {
    p: 3,
    textAlign: 'center',
  },
}

export const paginationOverride = {
  mx: { xs: -2, sm: 0, md: 0 },
  '& [data-testid="pagination-container"], & [class*="pagination"]': {
    justifyContent: 'flex-start !important',
    px: { xs: 2, sm: 0, md: 0 },
  },
}

export const clientsTableWrapper = {
  ...paginationOverride,
  position: 'relative',
}
